import { NextResponse } from 'next/server';
import { pool } from '@/lib/db';

export async function GET() {
  try {
    // Test database connection
    const [rows] = await pool.execute('SELECT 1 as test');
    
    // Check if gyms table exists
    const [tables] = await pool.execute(
      "SHOW TABLES LIKE 'gyms'"
    );
    
    return NextResponse.json({
      success: true,
      message: 'Database connection successful',
      tablesFound: tables,
      testQuery: rows,
    });
  } catch (error) {
    console.error('Database test error:', error);
    return NextResponse.json(
      { 
        error: 'Database connection failed',
        details: error instanceof Error ? error.message : 'Unknown error'
      },
      { status: 500 }
    );
  }
}
